import { useEffect, useState } from "react";
import Box from "elements/Box";
import {
  Chip,
  IconButton,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { ApiRequest } from "GlobalFunctions";
import { useSocketEvent } from "SocketContext";
import EmailIcon from "@mui/icons-material/Email";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import MessagesViewer from "./MessagesViewer";

import "assets/css/main.css";

export default function MessagesList(props: any) {
  const { setLoading } = props;

  const [list, setList] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [openViewer, setOpenViewer] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);

  useEffect(() => {
    setLoading(true);
    loadList();
  }, [page]);

  // Actualizar lista en tiempo real via Socket.IO
  useSocketEvent('new_message', () => loadList());
  useSocketEvent('messages_updated', () => loadList());

  /*=============================================
  LOAD LIST
  =============================================*/
  const loadList = () => {
    ApiRequest({
      url: "/messages/list",
      method: "get",
      headers: { ltkn: localStorage.getItem("ltkn") },
      query: { page },
      setResponse: (response: any) => {
        setList(response.list);
        setTotalPages(response.total_pages);
        setLoading(false);
      },
    });
  };

  return (
    <div id="MessagesList" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Mensajes</h2>
            <span className="h2_subtitle">Mensajes enviados desde la app</span>
          </div>
        </div>

        <Box id="MessagesListIn" className="box100">
          <TableContainer>
            <Table aria-label="messages table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}></TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Remitente</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Mensaje</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Estado</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Fecha</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item: any, i: number) => (
                  <TableRow
                    key={i}
                    hover
                    role="checkbox"
                    sx={{ fontWeight: item.is_read ? "normal" : "bold" }}
                  >
                    <TableCell sx={{ width: 40 }}>
                      {item.is_read ? (
                        <MarkEmailReadIcon sx={{ color: "#0BA757" }} />
                      ) : (
                        <EmailIcon sx={{ color: "#1976d2" }} />
                      )}
                    </TableCell>
                    <TableCell sx={{ fontWeight: item.is_read ? "normal" : 700 }}>
                      {item.user_name}
                    </TableCell>
                    <TableCell
                      sx={{
                        maxWidth: 400,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontWeight: item.is_read ? "normal" : 700,
                      }}
                    >
                      {item.body}
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={item.is_read ? "Leído" : "No leído"}
                        color={item.is_read ? "default" : "primary"}
                        variant={item.is_read ? "outlined" : "filled"}
                      />
                    </TableCell>
                    <TableCell>
                      {new Date(item.created_at).toLocaleString("es-ES", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => {
                          setActiveItem(item.message_id);
                          setOpenViewer(true);
                        }}
                      >
                        <VisibilityOutlinedIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(_event, value) => setPage(value)}
            color="primary"
            style={{ marginTop: "20px", alignSelf: "center" }}
          />
        </Box>
      </div>

      <MessagesViewer
        open={openViewer}
        setOpen={setOpenViewer}
        message_id={activeItem}
        loadList={loadList}
      />
    </div>
  );
}
